import React, { useState } from 'react'
import PropTypes from 'prop-types'
import priceCalculator from './helpers/price_calculator'
import './assets/inputs.scss'
import TubeSVG from './assets/TubeSVG.jsx'

const CutMaker = ({
  products, defaultSize, vatRate, onAddCut
}) => {
  const [quantity, setQuantity] = useState(0)
  const [length, setLength] = useState(0)

  const findSelectedProduct = (id) => products.find((product) => product.id === id)

  const findInitialProduct = () => products.find((product) => product.size_a === defaultSize)

  const [selectedProduct, setSelectedProduct] = useState(findInitialProduct() || '')

  const quantityChanged = (event) => {
    const { value } = event.target
    setQuantity(value)
  }

  const lengthChanged = (event) => {
    const { value } = event.target
    setLength(value)
  }

  const onSelect = (event) => {
    const { value } = event.target
    const product = findSelectedProduct(parseInt(value, 10))
    setSelectedProduct(product)
  }

  const priceEachWithoutVAT = () => priceCalculator.priceEachWithoutVAT(length, selectedProduct)

  const priceEachWithVAT = () => priceCalculator.priceEachWithVAT(length, selectedProduct, vatRate)

  const priceWithoutVAT = () => priceCalculator.priceWithoutVAT(length, selectedProduct, quantity)

  const priceWithVAT = () => (
    priceCalculator.priceWithVAT(length, selectedProduct, quantity, vatRate)
  )

  const selectOptions = () => {
    const options = [<option key="-1" disabled value="">Choose</option>]
    products.forEach((product) => {
      options.push(
        <option value={product.id} key={product.id} onSelect={onSelect}>{`${product.size_a} mm`}</option>
      )
    })
    return options
  }

  const addCutAndReset = () => {
    onAddCut(selectedProduct, length, quantity)
    setQuantity(0)
    setLength(0)
  }

  const canAddCut = () => selectedProduct && length >= 100 && length <= 6000 && quantity >= 1 && quantity <= 999

  return (
    <fieldset className="cuts-fieldset group">
      <h2>Add Tube Lengths</h2>
      <div className="cuts-fieldset-inner">
        <div className="Splashback-fields">
          <div className="cts-field">
            <div className="cts-step">1</div>
            <label htmlFor="size">Size</label>
            <div className="cts-inputs">
              <div className="cts-input">
                <select
                  value={selectedProduct && selectedProduct.id}
                  id="size"
                  name="size"
                  className="input input-size table-input"
                  onChange={onSelect}
                  required={true}
                >
                  {selectOptions()}
                </select>
              </div>
            </div>
          </div>
          <div className="cts-field">
            <div className="cts-step">2</div>
            <label htmlFor="length">Length (mm)</label>
            <div className="cts-inputs">
              <div className="cts-input">
                <input
                  id="length"
                  name="length"
                  onChange={lengthChanged}
                  value={length}
                  className="input input-length table-input"
                  type="number"
                  min="100"
                  max="6000"
                />
              </div>
            </div>
          </div>
          <div className="cts-field">
            <div className="cts-step">3</div>
            <label htmlFor="quantity">Quantity</label>
            <div className="cts-inputs">
              <div className="cts-input">
                <input
                  id="quantity"
                  name="quantity"
                  onChange={quantityChanged}
                  value={quantity}
                  type="number"
                  min="1"
                  max="999"
                  className="qty-input"
                />
              </div>
            </div>
          </div>
          <div className="cts-field">
            <button id="add" onClick={addCutAndReset} className="btn-cta btn" disabled={!canAddCut()}>Add Tube Lengths</button>
          </div>
        </div>
      </div>
      <div className="Splashback-prices">
        {canAddCut() && <div className="tube-svg"><TubeSVG size={selectedProduct.size_a} length={length}/></div>}
        <h3>Price</h3>
        <p className="Splashback-price">
          <label htmlFor="price_without_vat">Ex VAT: </label>
          <output
            id="price_without_vat"
            name="price_without_vat"
            htmlFor="size length quantity"
            className="output"
          >
            £{priceWithoutVAT()}
          </output>
          <br/>
          <label htmlFor="price_with_vat">Inc VAT: </label>
          <output
            id="price_with_vat"
            name="price_with_vat"
            htmlFor="size length quantity"
            className="output"
          >
            £{priceWithVAT()}
          </output>
        </p>
        <p className="Splashback-price-each">
          <label htmlFor="price_each_without_vat">Ex VAT (each): </label>
          <output
            id="price_each_without_vat"
            name="price_each_without_vat"
            htmlFor="size length quantity"
            className="output"
          >
            £{priceEachWithoutVAT()}
          </output>
          <br/>
          <label htmlFor="price_each_with_vat">Inc VAT (each): </label>
          <output
            id="price_each_with_vat"
            name="price_each_with_vat"
            htmlFor="size length quantity"
            className="output"
          >
            £{priceEachWithVAT()}
          </output>
        </p>
      </div>
    </fieldset>
  )
}

CutMaker.propTypes = {
  onAddCut: PropTypes.func,
  deleteField: PropTypes.func,
  products: PropTypes.array,
  defaultSize: PropTypes.string,
  vatRate: PropTypes.number
}

export default CutMaker
